import * as React from "react";

const SvgIcnVideoBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M19.469 6.784c.062 0 .112.008.148.024.037.015.06.023.07.023a.511.511 0 01.313.484V16.3a.485.485 0 01-.086.281.531.531 0 01-.227.188.254.254 0 00-.07.023.337.337 0 01-.133.024c-.062 0-.125-.003-.187-.008a.308.308 0 01-.188-.102L15 14.316v1.953c0 .291-.102.539-.305.742a.992.992 0 01-.726.305H5.03a.992.992 0 01-.726-.305A1.01 1.01 0 014 16.269V7.33c0-.291.102-.539.305-.742a.992.992 0 01.726-.305h8.938c.291 0 .536.102.734.305.198.203.297.45.297.742v1.985l4.031-2.375a.464.464 0 01.227-.125.977.977 0 01.21-.032z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnVideoBold;
